import { Session } from 'types/common';
import { StorageKey, StorageUtils } from './local-storage';

// set session to local
export const setSession = (session: Session | null) => {
  const session_copy = { ...session };
  StorageUtils.saveObject(StorageKey.SESSION, session_copy);
};

// get
export const getSession = () => {
  const session = StorageUtils.getObject(StorageKey.SESSION);
  if (session) {
    return session;
  } else {
    localStorage.removeItem(StorageKey.SESSION);
  }

  setSession(null);
  localStorage.removeItem(StorageKey.SESSION);
  return null;
};

export const deleteSession = () => {
  StorageUtils.saveObject(StorageKey.SESSION, {});
};

